import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router';
import { NextStepNavigationContext } from '|/context';
import useNavigationState from '../use-navigation-state';

const useNavigateToNextStep = () => {
  const { handleNextStep } = useContext(NextStepNavigationContext);
  const navigate = useNavigate();
  const navigationState = useNavigationState();
  const callback = useCallback(() => {
    if (handleNextStep !== null) {
      handleNextStep();
    } else {
      navigate('/next-step', { state: navigationState });
    }
  }, [handleNextStep, navigate, navigationState]);

  return callback;
};

export default useNavigateToNextStep;
